import React, { useState, useEffect } from 'react'
import { useAtom } from 'jotai'
import { useFirstMountState, useDebounce } from 'react-use'
import axios from 'axios'

// store
import {
  userContents,
  userEmail,
  isLoggedIn,
  isSharedContent,
} from '@/utils/op-types/store'
import getUser from 'pages/api/get-user'

const AutoSaver = ({ id }) => {
  const [getUserContents] = useAtom(userContents)
  const [getUserEmail] = useAtom(userEmail)
  const [getSharedContent] = useAtom(isSharedContent)

  const isFirstMount = useFirstMountState()
  const [autoSaveStart, setAutoSaveStart] = useState(false)

  // debouce save
  const [, debounceAutoSave] = useDebounce(
    async () => {
      if (!isFirstMount) {
        // post to server if LoggedIn
        if (getSharedContent) {
          // console.log('do not save')
        } else if (getUserEmail) {
          setAutoSaveStart(true)

          axios
            .post('/api/universal-types/save-user-content', {
              content: getUserContents,
              email: getUserEmail,
              onepagerId: id,
            })
            .then(() => {
              setTimeout(function () {
                setAutoSaveStart(false)
              }, 1000)
            })

          // axios
          //   .post('/api/rest/save-user-content-email', {
          //     // content: getUserContents,
          //     // email: getUserEmail,
          //     // onepagerId: id,

          //     // email: getUserEmail,
          //     // submission: true,
          //     // templateId: id,
          //     // content: getUserContents,
          //   })
          //   .then(() => {
          //     setTimeout(function () {
          //       setAutoSaveStart(false)
          //     }, 1000)
          //   })
        } else {
          setTimeout(function () {
            setAutoSaveStart(false)
          }, 1000)
        }
      }
    },
    2000,
    [getUserContents]
  )

  if (autoSaveStart) {
    return (
      <div className="fixed bottom-6 right-6 p-3 shadow-lg rounded bg-gray-600 text-white font-bold text-2xl z-50">
        Saving...
      </div>
    )
  } else {
    return null
  }
}

export default AutoSaver
